import React from 'react';
import styled, { keyframes } from 'styled-components';

import Text from 'components/Text';

export const ErrorText = ({ errorText }) => {
  if (!errorText) return null;

  return (
    <ErrorContain>
      <ErrorInnerContain>
        <FlexRow>
          <Text.FieldError>{errorText}</Text.FieldError>
        </FlexRow>
      </ErrorInnerContain>
    </ErrorContain>
  );
};

export default ErrorText;

const zoomIn = keyframes`
  0% {
    transform: translateX(-20px); 
  }
  60% {
    transform: translateX(10px); 
  }
  100% {
    transform: translateX(0px); 
  }
`;

const ErrorInnerContain = styled.div`
  padding: 4px;
  position: relative;

  background-color: #ffffff;

  animation-duration: 0.3s;
  animation-name: ${zoomIn};
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;

  display: flex;
  justify-content: flex-start;
`;

const ErrorContain = styled.div`
  z-index: 9999;
  margin-top: 8px;
}
`;

const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`;
